/**
 * Custom field type components registry.
 *
 * This file exports all field type components and provides a mapping
 * from CustomFieldType enum to component for dynamic rendering.
 */

import { defineAsyncComponent } from 'vue';
import type { Component } from 'vue';
import { CustomFieldType } from '@nova/core';

// Import all field type components
export { default as CustomFieldString } from './CustomFieldString.vue';
export { default as CustomFieldBigstring } from './CustomFieldBigstring.vue';
export { default as CustomFieldNumber } from './CustomFieldNumber.vue';
export { default as CustomFieldBool } from './CustomFieldBool.vue';
export { default as CustomFieldDate } from './CustomFieldDate.vue';
export { default as CustomFieldTimestamp } from './CustomFieldTimestamp.vue';
export { default as CustomFieldEmail } from './CustomFieldEmail.vue';
export { default as CustomFieldDropdown } from './CustomFieldDropdown.vue';
export { default as CustomFieldDropdownmultiselect } from './CustomFieldDropdownmultiselect.vue';
export { default as CustomFieldCombobox } from './CustomFieldCombobox.vue';
export { default as CustomFieldDocument } from './CustomFieldDocument.vue';
export { default as CustomFieldMultidocument } from './CustomFieldMultidocument.vue';
export { default as CustomFieldAction } from './CustomFieldAction.vue';

export const CustomFieldPhone = defineAsyncComponent(() => import('./CustomFieldPhone.vue'));

// Component registry map for dynamic rendering
// TODO: Import components dynamically if needed for better tree-shaking
import CustomFieldString from './CustomFieldString.vue';
import CustomFieldBigstring from './CustomFieldBigstring.vue';
import CustomFieldNumber from './CustomFieldNumber.vue';
import CustomFieldBool from './CustomFieldBool.vue';
import CustomFieldDate from './CustomFieldDate.vue';
import CustomFieldTimestamp from './CustomFieldTimestamp.vue';
import CustomFieldEmail from './CustomFieldEmail.vue';
import CustomFieldDropdown from './CustomFieldDropdown.vue';
import CustomFieldDropdownmultiselect from './CustomFieldDropdownmultiselect.vue';
import CustomFieldCombobox from './CustomFieldCombobox.vue';
import CustomFieldDocument from './CustomFieldDocument.vue';
import CustomFieldMultidocument from './CustomFieldMultidocument.vue';
import CustomFieldAction from './CustomFieldAction.vue';

/**
 * Map from CustomFieldType to Vue component.
 * Used for dynamic component rendering based on field.type.
 *
 * @example
 * ```ts
 * import { CUSTOM_FIELD_COMPONENTS } from '@satellite/components/custom_forms/field_types';
 *
 * const component = CUSTOM_FIELD_COMPONENTS[field.type];
 * ```
 */
export const CUSTOM_FIELD_COMPONENTS: Record<CustomFieldType, Component> = {
  [CustomFieldType.String]: CustomFieldString,
  [CustomFieldType.BigString]: CustomFieldBigstring,
  [CustomFieldType.Number]: CustomFieldNumber,
  [CustomFieldType.Bool]: CustomFieldBool,
  [CustomFieldType.Date]: CustomFieldDate,
  [CustomFieldType.Timestamp]: CustomFieldTimestamp,
  [CustomFieldType.Email]: CustomFieldEmail,
  [CustomFieldType.Phone]: CustomFieldPhone,
  [CustomFieldType.DropDown]: CustomFieldDropdown,
  [CustomFieldType.DropDownMultiSelect]: CustomFieldDropdownmultiselect,
  [CustomFieldType.ComboBox]: CustomFieldCombobox,
  [CustomFieldType.Document]: CustomFieldDocument,
  [CustomFieldType.MultiDocument]: CustomFieldMultidocument,
  [CustomFieldType.Action]: CustomFieldAction
};
